import { stringify } from "query-string";
import { APPLICATIONS } from "./constants";

export default function(adapter) {
  return {
    all: (partId, page) =>
      adapter.post(`/parts/${partId}/all`, { search: { page } }),
    bookmarks: {
      search: search => adapter.post("/parts/bookmarks/search", { search }),
      create: partId => adapter.post(`parts/${partId}/bookmarks`),
      destroy: partId => adapter.delete(`parts/${partId}/bookmark`)
    },
    create: part => adapter.post("/parts", { part }),
    export: params => adapter.get(`/parts/export?${stringify(params)}`),
    import: data => adapter.post("/parts/import", data),
    merge: (partId, params) =>
      adapter.post(`/parts/${partId}/merge`, { part: { ...params } }),
    poPartSearch: params =>
      adapter.post("/parts/search", {
        search: { ...params, sold_recently_status: true }
      }),
    rankingStats: (noSellableQty, filter) =>
      adapter.get("/parts/ranking_stats", {
        params: { no_sellable_qty: noSellableQty, filter }
      }),
    search: params => adapter.post("/parts/search", { search: params }),
    searchPartsAndAlternates: params =>
      adapter.post("/parts/search_parts_and_alternates", { search: params }),
    sellableQuantities: id => adapter.get(`/parts/${id}/sellable_quantities`),
    show: id => adapter.get(`/parts/${id}`),
    tierTypeStats: () => adapter.get("/parts/tier_type_stats"),
    update: (id, part) => adapter.put(`/parts/${id}`, { part }),
    alternates: {
      create: (partId, alternate) =>
        adapter.post(`/parts/${partId}/alternates`, { alternate }),
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/alternates/search`, { search })
    },
    applications: {
      list: (id, page, limit) =>
        adapter.get(`/parts/${id}/applications`, { params: { page, limit } }),
      of: type => {
        const {
          applicationResourceName,
          applicableResourceName,
          formResourceName,
          searchFilterParam
        } = APPLICATIONS[type];

        return {
          applicables: partNumber =>
            adapter.post(`/${applicableResourceName}/search`, {
              search: { [searchFilterParam]: partNumber, limit: 30 }
            }),
          create: (partId, data) =>
            adapter.post(`/parts/${partId}/${applicationResourceName}`, {
              [formResourceName]: data
            })
        };
      }
    },
    incomingQuotes: {
      bulkCreate: (partId, data) =>
        adapter.post(`/parts/${partId}/incoming_quotes/bulk_create`, {
          incoming_quote: data
        }),
      create: (partId, data) =>
        adapter.post(`/parts/${partId}/incoming_quotes`, {
          incoming_quote: data
        })
    },
    incomingQuoteLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/incoming_quote_line_items/search`, {
          search
        })
    },
    inventories: {
      search: (partId, filters = {}) =>
        adapter.post(`/parts/${partId}/inventories/search`, {
          search: { ...filters }
        })
    },
    lotLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/lot_line_items/search`, {
          search
        })
    },
    managedRepairOrderLineItems: {
      search: (partId, search) =>
        adapter.post(
          `/parts/${partId}/managed_repair_order_line_items/search`,
          {
            search
          }
        )
    },
    outgoingQuotes: {
      create: (partId, data) => {
        data.outgoing_quote_line_item.part_id = partId;
        return adapter.post("/outgoing_quotes", { outgoing_quote: data });
      }
    },
    outgoingQuoteLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/outgoing_quote_line_items/search`, {
          search
        }),
      search_grouped: (partId, search) =>
        adapter.post(
          `/parts/${partId}/outgoing_quote_line_items/search_grouped`,
          {
            search
          }
        )
    },
    purchaseOrderAndLots: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/purchase_and_lots/search`, {
          search
        })
    },
    purchaseOrderLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/purchase_order_line_items/search`, {
          search
        })
    },
    repairOrderLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/repair_order_line_items/search`, {
          search
        }),
      stats: partId =>
        adapter.post(`/parts/${partId}/repair_order_line_items/stats`)
    },
    repairQuoteLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/repair_quote_line_items/search`, {
          search
        })
    },
    salesOrderLineItems: {
      search: (partId, search) =>
        adapter.post(`/parts/${partId}/sales_order_line_items/search`, {
          search
        })
    }
  };
}



// WEBPACK FOOTER //
// ./app/modules/parts/api.js